export enum NotificationAudio {
  NEW_ORDER = '../../assets/sounds/notification-new-order.wav',
  SILENT = '../../assets/sounds/silent.wav',
}
